import { Component, Input, output } from "@angular/core";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { TrimDirective } from "common/trim.directive";
import { DebouncedChangeDirective } from "common/debounced-change.directive";

@Component({
	selector: "stages-description-editor-imagemap",
	templateUrl: "./description-editor-imagemap.component.html",
	imports: [ReactiveFormsModule, TrimDirective, FormsModule, DebouncedChangeDirective],
})
export class DescriptionEditorImageMapComponent {
	// TODO: Skipped for migration because:
	//  Your application code writes to the input. This prevents migration.
	@Input()
	imageRef!: stages.images.ImageReference;

	readonly imageMapChanged = output<void>();

	constructor() {}

	onChange(): void {
		// TODO: The 'emit' function requires a mandatory void argument
		this.imageMapChanged.emit();
	}
}
